// src/layouts/openPages/live/LiveApis.js
import axios from 'axios';
import { vendorAuthApi, vendorThingApi, vendorThingDeviceDetailsApi } from '../../../config';

const instance = axios.create({ timeout: 36000 });

let authParams = new URLSearchParams(window.location.search);
if (authParams.get('c')) authParams.set('trackingCode', authParams.get('c'));

let session = null;
let thingModel = null;
let thingUpdateCallback = null;
let thingUpdateError = null;
let updateCallback = null;
let updateLoop = null;
let motionLoop = null;
let previousLocation = null;
let currentLocation = null;
let nextLocation = null;

// --- GET THING ---
export function getThing(callback, error) {
  thingUpdateCallback = callback;
  thingUpdateError = error;

  return instance
    .post(vendorAuthApi, Object.fromEntries(authParams))
    .then((res) => {
      session = res.data.session;
      loadThing(callback, error);
    })
    .catch((err) => error(err.response?.data || err.message));
}

function loadThing(callback, error) {
  instance
    .get(vendorThingApi, { headers: { 'x-dhundhoo-session': session } })
    .then((res) => {
      if (res.data.journeyAvailable === false) {
        error('The bus is in parking. You will be able to track the bus when the trip starts.');
      } else {
        thingModel = res.data;
        callback(res.data);
      }
    })
    .catch((err) => error(err.response?.data || err.message));
}

// --- REAL-TIME UPDATES (NO JOURNEY) ---
export function startThingUpdatesNoJourney(callback) {
  updateCallback = callback;
  if (updateLoop) clearInterval(updateLoop);

  const fetchUpdate = () => {
    if (document.visibilityState === 'hidden') return;

    instance
      .get(`${vendorThingDeviceDetailsApi}?apiKey=${authParams.get('apiKey')}&thingId=${authParams.get('thingId')}`, {
        headers: { 'x-dhundhoo-session': session },
      })
      .then((res) => {
        const loc = res.data[0];
        if (!loc?.latitude || !loc?.longitude) return;

        previousLocation = currentLocation;
        currentLocation = nextLocation;
        nextLocation = { latitude: loc.latitude, longitude: loc.longitude };

        if (updateCallback) updateCallback(nextLocation);
        motion();
      })
      .catch(console.warn);
  };

  fetchUpdate();
  updateLoop = setInterval(fetchUpdate, 8000);

  return () => {
    if (updateLoop) clearInterval(updateLoop);
    if (motionLoop) clearInterval(motionLoop);
    updateCallback = null;
  };
}

// --- SMOOTH MOTION ---
function motion() {
  if (motionLoop) clearInterval(motionLoop);
  let steps = 0;
  const total = 80; // 8s / 100ms

  motionLoop = setInterval(() => {
    if (!previousLocation || !nextLocation || !updateCallback) {
      clearInterval(motionLoop);
      return;
    }
    if (steps >= total) {
      currentLocation = nextLocation;
      updateCallback(currentLocation);
      clearInterval(motionLoop);
      return;
    }

    const p = steps / total;
    currentLocation = {
      latitude: previousLocation.latitude + (nextLocation.latitude - previousLocation.latitude) * p,
      longitude: previousLocation.longitude + (nextLocation.longitude - previousLocation.longitude) * p,
    };
    updateCallback(currentLocation);
    steps++;
  }, 100);
}

// --- STOP UPDATES ---
export function stopUpdates() {
  if (updateLoop) clearInterval(updateLoop);
  if (motionLoop) clearInterval(motionLoop);
  updateCallback = null;
}